import styled from "styled-components";
import { Colors } from "../../../shared/colors/colors";
import { StyleSheet } from "@react-pdf/renderer";

export const ContainerButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;
export const ReajusteValoresFinanceirosContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  padding: 0;
  border-radius: 0;
  border: 0;
`;

export const TextAreaObservacao = styled.textarea`
  resize: vertical;
  min-height: 118px;
  width: 100%;
  border: 1px solid ${Colors.borderInput};
  border-radius: 8px;
  padding: 12px;
  font-family: inherit;
  font-size: 16px;
  outline: none;
  &:disabled {
    background-color: #f5f6f7;
    cursor: not-allowed;
  }
`;


export const LoadingGif = styled.img`
  width: 100px;
  height: 100px;
`;

export const MainContainer = styled.div`
  display: flex;
  width: 90vw;
  flex-direction: column;
  height: 100%;
  gap: 16px;
`;

export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


export const EmptySearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  text-align: center;
  background-color: ${Colors.backgroundColorTable};
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 20px 0;
`;

export const EmptySearchMessage = styled.h4`
  color: ${Colors.primary};
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RelatorioStyles = StyleSheet.create({
  page: { padding: 30, position: "relative" },

  // Cabeçalho
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 20,
    position: "relative",
  },
  logoContainer: {
    position: "absolute",
    left: 80,
    top: 0,
    width: 45,
    height: 45,
  },
  logo: {
    width: 45,
    height: 45,
  },
  headerText: {
    flex: 1,
    alignItems: "center",
  },
  institution: { fontSize: 12, fontWeight: "bold" },
  details: { fontSize: 10 },
  title: { fontSize: 14, fontWeight: "bold", marginTop: 10 },

  // Filtros
  filtersMainContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "auto",
    width: "auto",
  },
  filters: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    marginTop: 8,
    gap: 8,
  },
  filterText: {
    fontSize: 12,
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    gap: 5,
  },
  filterTextBold: {
    fontSize: 12,
    fontWeight: "bold",
  },

  // Tabela
  table: { display: "flex", width: "auto", marginTop: 20 },
  row: { flexDirection: "row" },
  cellHeaderName: {
    fontWeight: "bold",
    padding: 5,
    width: "35%",
    fontSize: 8,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },
  cellHeader: {
    fontWeight: "bold",
    padding: 5,
    width: "12%",
    fontSize: 8,
    backgroundColor: Colors.backgroundColorTable,
    border: `1px solid ${Colors.black}`,
  },
  cellPreviousName: {
    padding: 5,
    width: "35%",
    fontSize: 8,
    border: `1px solid ${Colors.black}`,
    fontWeight: "normal",
    color: "red",
  },
  cellPrevious: {
    padding: 5,
    width: "12%",
    fontSize: 8,
    border: `1px solid ${Colors.black}`,
    fontWeight: "normal",
    color: "red",
  },
  cellCurrentName: {
    padding: 5,
    width: "35%",
    fontSize: 8,
    border: `1px solid ${Colors.black}`,
    fontWeight: "bold",
    color: "green",
  },
  cellCurrent: {
    padding: 5,
    width: "12%",
    fontSize: 8,
    border: `1px solid ${Colors.black}`,
    fontWeight: "bold",
    color: "green",
  },
  cellFull: {
    padding: 5,
    width: "100%",
    border: `1px solid ${Colors.black}`,
  },

  // Rodapé
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    fontSize: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    color: "#555",
  },
});

